<template>
  <div class="goods-box my-form">
    <!-- <img v-if="user && user.avatarUrl" :src="user.avatarUrl"> -->

    <div class="registered">
      <van-form
        @submit="onSubmit"
        label-width="1.85rem"
        class="reg_from"
        show-error
        :show-error-message="false"
      >
        <van-field
          v-model="form.Username"
          name="Name"
          label="Name"
          placeholder="Please enter your name"
          required
          :rules="[{ required: true, message: 'Please enter your name' }]"
        />
        <van-field
          v-model="form.email"
          name="E-mail"
          label="E-mail"
          placeholder="Please enter your e-mail"
          required
          :rules="[{ required: true, message: 'Please enter your e-mail' }]"
        />
        <van-field
          v-model="code"
          center
          clearable
          label="Code"
          placeholder="Please enter the code"
          required
          :rules="[{ required: true, message: 'Please enter the code' }]"
        >
          <template #button>
            <span class="code" v-if="newTimer">{{ newCount || 0 }}s</span>
            <span class="sendcode code" v-else @click="getCode">get</span>
          </template>
        </van-field>
        <van-field
          v-model="form.Password"
          name="Password"
          label="Password"
          placeholder="Please enter your password"
          required
          :rules="[{ required: true, message: 'Please enter your password' }]"
        />
        <van-field
          v-model="form.CompName"
          type="text"
          name="Company"
          label="Company"
          placeholder="Please enter your company"
          required
          :rules="[{ required: true, message: 'Please enter your company' }]"
        />
        <van-field
          v-model="form.JobTitle"
          type="text"
          name="Job title"
          label="Job title"
          placeholder="Please enter your job title "
          required
          :rules="[{ required: true, message: 'Please enter your job title ' }]"
        />
        <van-field
          v-model="form.phoneText"
          name="Mobile"
          label="Mobile"
          placeholder="Please enter your mobile "
        />
        <van-field
          readonly
          clickable
          name="Region"
          :value="form.area"
          label="Region"
          placeholder="Please select region "
          @click="showArea = true"
          required
          :rules="[{ required: true, message: 'Please select region ' }]"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-picker
            title="Cuntry"
            confirm-button-text="confirm"
            cancel-button-text="cancel"
            show-toolbar
            :columns="countryList"
            @confirm="onConfirm"
            @cancel="showArea = false"
          />
          <!-- <van-area
            :value="cityCode"
            :area-list="areaList"
            @confirm="onCity"
            @cancel="showArea = false"
          /> -->
        </van-popup>
        <van-cell
          title="Interest"
          class="cate_cell"
          is-link
          @click="regCareShow"
          v-if="categoryNum != ''"
        >
          <p v-if="categoryNum != ''">
            <span>{{ categoryNum }}</span
            >&nbsp;choosed
          </p>
        </van-cell>
        <van-cell
          title="Interest"
          class="cate_cell"
          is-link
          value="Please select one"
          @click="regCareShow"
          v-if="categoryNum == ''"
        />

        <!-- <div>
          <p class="intro_title">Self-introduction</p>
          <van-field
            v-model="form.introduction"
            rows="4"
            type="textarea"
            class="intro_cell"
            maxlength="500"
            placeholder="Add a brief introduction"
            :rules="[{ required: true, message: 'Add a brief introduction' }]"
          />
        </div> -->

        <!-- <div class="vant-btn" v-if="user">
          <van-button round block type="info"  native-type="submit">
            Submit
          </van-button>
        </div> -->
        <div class="vant-btn sub_btn" >
          <p @click="LinkToLogin"><i class="icon iconfont icon-xiala"></i> I have an account</p>
          <van-button round block type="info" native-type="submit"
            >Submit</van-button
          >
        </div>
      </van-form>
    </div>

    <!-- 注册条款 -->
    <frame
      :showFrame="showFrame"
      @agree="
        showFrame = false;
        checkbox = true;
      "
    ></frame>

    <categoryPop
      ref="regCare"
      :cateList="categoryList"
      :selectList="categoryList1"
      @closePop="closePop"
    ></categoryPop>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations} from "vuex";
import provincial from "@/assets/js/provincial.json"; //省市区json
import frame from "./frame"; // 条款弹框
import categoryPop from "./categoryPop"; // 类别弹框

export default {
  data() {
    return {
      form: {
        Username: "", // 姓名
        email: "", // 邮箱
        phoneText: "", // 手机号
        Password: "",
        CompName: "", // 公司名
        JobTitle: "", // 职务
        area: "", // 省份
        category: "",
        introduction: "",
        flagStyle:'', // 国旗
      },
      //验证码
      code: "",
      count: 0,
      newCount: 0,
      timer: null,
      newTimer: null,
      codeKey: "",
      //验证码
      pattern: /^1[3456789]\d{9}$/, // 校验手机号

      areaList: [], // 地区数据
      areavalue: [], // 选中的地区数据
      cityCode: "", //省市区编号，默认
      checkbox: false,
      showArea: false,
      showFrame: false, //  显示条款
      categoryNum: "",
      categoryList1: [], //感兴趣类型的选中数组
      showCategory: false, // 显示类别
      countryList:[],
    };
  },
  components: { frame, categoryPop },
  computed: {
    ...mapGetters({
      user: "getUserInfo",
      categoryList: "getCategory",
      userId: "getUserId",
      hostInfo: "getHostInfo",
      exhibitionId: "getExhibitionId",
      regOrigin: "getRegOrigin",
      country:'getCountry',
    }),
  },
  created() {
    this.areaList = provincial;
    this.country.forEach(c=>{
      this.countryList.push(c.nameEn)
    })
    this.init();
  },
  methods: {
    ...mapActions({
      LinkToRegFinsh: "linkTo/LinkToRegFinsh",
      patchUser: "my/patchUser",
      sendCode: "my/sendCode",
      sendEamilCode: "my/sendEamilCode",
      validateCode: "my/validateCode",
      putPhone: "my/putPhone",
      regUser: "my/regUser",
      addReg: "en/addReg",
      LinkToLogin:'linkTo/LinkToLogin'
    }),
    ...mapMutations({
      setRegOrigin:'setRegOrigin'
    }),
    async init() {
      let exhibitionId = this.$route.params.id;
      console.log(exhibitionId, "exhibitionId");
      this.$store.commit("setExhibitionId", exhibitionId);
      await this.$Myapollo.getExhibitionInfo(this, exhibitionId, this.userId);
      await this.$Myapollo.getCategory(this, this.exhibitionId);
      await this.$Myapollo.getUserInfo(this);
      this.$Myapollo.addExhibitionView();
      console.log(this.user,'user');
      if(this.user) {
        this.form.Username = this.user.name;
        this.form.phoneText = this.user.phoneText;
        this.form.email=this.user.email
        this.form.CompName = this.user.company;
        this.form.JobTitle = this.user.jobTitle;
        if (this.user.inMember.category) {
          this.categoryList1 = this.user.inMember.category.split(";");
          this.categoryNum = this.categoryList1.length;
        }
        if (this.user.province && this.user.city && this.user.county) {
          this.areavalue = [this.user.province, this.user.city, this.user.county];
          this.form.area =
            this.user.province + "/" + this.user.city + "/" + this.user.county;
  
          // console.log(this.areavalue);
        } else if (this.user.province && this.user.city) {
          this.form.area = this.user.province + "/" + this.user.city;
          this.areavalue = [this.user.province, this.user.city];
        } else {
          this.form.area = this.user.province;
          this.areavalue = [this.user.province];
        }
        if(this.user.country) {
          this.form.area = this.user.country;
          this.form.flagStyle = this.user.flagStyle;
        }
        this.form.introduction = this.user.introduction;
      }
    },
    onCity(e) {
      //选择地区
      console.log(e, "选择地区");
      let areaList = [];
      e.forEach((c) => {
        areaList.push(c.name);
      });
      this.areavalue = areaList;
      this.form.area = areaList.join("/");
      this.showArea = false;
    },
    onConfirm(e){ // 选择国家 ， 国旗
      this.form.area = e;
      console.log(e, "选择国家");
      this.showArea = false;
      this.country.forEach(c=>{ // 选择国旗
        if(c.nameEn == e) {
          this.form.flagStyle = c.shortNameEn
        }
        // this.countryList.push(c.nameEn)
      })
      console.log(this.form.flagStyle,'this.form.flagStyle')
    },
    async onSubmit(values) {
      // let checkRes =  await this.Checkphone();
      // if(!checkRes) {
      //   return;
      // }
      
      let result=null;
      if(this.user&&this.user.inMember&&this.user.inMember.id){
        let opt={
          inMemberId: this.user.inMember.id,
          name: this.form.Username,
          email:this.form.email,
          phoneText: this.form.phoneText,
          password: this.form.Password,
          jobTitle: this.form.JobTitle,
          company: this.form.CompName,
          country: this.form.area,
          flagStyle: this.form.flagStyle,
          category: this.form.category,
          originType: this.regOrigin ? this.regOrigin.originType : "",
          originId: this.regOrigin ? this.regOrigin.originId : "",
          originRemark: this.regOrigin ? this.regOrigin.originRemark : "",
          originLang: "en",
        }
        result=await this.regUser(opt);
      }else{
        let body = {
          name: this.form.Username,
          phoneText: this.form.phoneText,
          password: this.form.Password,
          jobTitle: this.form.JobTitle,
          company: this.form.CompName,
          country: this.form.area,
          flagStyle: this.form.flagStyle,
          introduction: this.form.introduction,
          email: this.form.email,
          exhibitionId: this.exhibitionId,
          category: this.form.category,
          originType: this.regOrigin ? this.regOrigin.originType : "",
          originId: this.regOrigin ? this.regOrigin.originId : "",
          originRemark: this.regOrigin ? this.regOrigin.originRemark : "",
          originLang: "en",
        };
        result =  await this.addReg(body);
      }
      if(result.result){ // 注册成功
        this.$toast.success('success');
        this.$Myapollo.getUserInfo(this);
        this.LinkToRegFinsh();
        this.setRegOrigin(null); // 清除注册的来源，防止在别的展会注册时，来源有误
      } else{  // 注册失败
        this.$toast.fail(result.message);
      }
    },

    regCareShow() {
      // 打开类别弹框
      this.$refs["regCare"].open();
    },

    closePop(checkList, vals) {
      // 选中类别并关闭弹框
      console.log(checkList, "选中的类别", vals);
      this.categoryNum = vals.length;
      this.form.category = checkList;
      this.categoryList1 = checkList.split(";");
      console.log(this.categoryList1, "this.categoryList1");
      console.log(this.form.category, "this.form.category");
    },

    //手机号校验
    validatorPhone(val) {
      return /^1[3456789]\d{9}$/.test(val);
    },
    // 邮箱验证
    validatorEamil(val) {
      return /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val);
    },
    // 获取邮箱验证码
    async getCode() {
      console.log(this.form.email, "获取邮箱验证码");
      if (!this.validatorEamil(this.form.email)) {
        this.$toast.fail("error Eamil");
        return;
      } else {
        this.newDownTime();
        let res = await this.sendEamilCode({
          email: this.form.email,
        });
        if (res.result) {
          this.$toast.success("send success");
          this.codeKey = res.data.key;
        } else {
          this.$toast.fail("fail");
        }
      }
    },
    //验证手机号
    async Checkphone() {
      let res = await this.validateCode({
        key: this.codeKey,
        code: this.code,
      });
      return new Promise((resolve, reject) => {
        if (res == true) {
          this.resetDown();
          resolve(true);
        } else {
          this.$toast.fail("code fail");
          this.resetDown();
          resolve(false);
        }
      });
    },

    resetDown() {
      // 重置验证码
      clearInterval(this.newTimer);
      this.newCount = 0;
      this.newTimer = null;
      this.code = "";
    },

    //新手机号倒计时
    newDownTime() {
      const newTIME_COUNT = 60;
      if (!this.newTimer) {
        this.newCount = newTIME_COUNT;
        const newTimer = setInterval(() => {
          let count = this.newCount;
          if (count > 0 && count <= newTIME_COUNT) {
            count--;
            this.newCount = count;
          } else {
            clearInterval(this.newTimer);
            this.newTimer = null;
          }
        }, 1000);
        this.newTimer = newTimer;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin: 0.45rem 0;
  }
  .registered {
    width: 100%;
    padding-bottom: 0.2rem;
    .code {
      font-size: 0.3rem;
    }
    .sendcode {
      color: #0190fe;
    }
    .single-checkbox {
      margin: 0.6rem 0 0.8rem 0.3rem;
      display: flex;
      p {
        font-size: 0.3rem;
        margin-left: 5px;
        color: #666;
      }
      span {
        font-size: 0.3rem;
        color: #1890ff;
      }
    }
    .vant-btn {
      // position: fixed;
      // left: 0;
      // bottom: 0;
      // z-index: 100;
      // width: 100%;
      // background: #fff;
      // height: 0.94rem;
      &.sub_btn{
        position: fixed;
        bottom: 0.2rem;
        left: 0;
        right: 0;
      }
      display: flex;
      align-items: center;
      justify-content: center;
      margin: .66rem .3rem 0;
      // box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.2);
      .van-button--block {
        width: 4rem;
        height: 0.74rem;
        line-height: 0.74rem;
      }
      span {
        font-size: 0.3rem;
      }
      p{
        width: 50%;
        font-size: .26rem;
        color: #666;
        .icon{
          display: inline-block;
          transform: rotate(90deg);
        }
      }
    }
    ::v-deep .reg_from {
      .intro_title {
        height: 0.77rem;
        display: flex;
        align-items: center;
        padding-left: 0.3rem;
        font-size: 0.3rem;
        color: #333;
      }
      .van-cell {
        padding: 0 0.3rem;
        height: 0.98rem;
        display: flex;
        align-items: center;
        // justify-content: center;
        &.intro_cell {
          height: 2.6rem;
        }
        &.cate_cell {
          .van-cell__title {
            flex: 0.4;
          }

          .van-cell__value {
            text-align: left;
            p {
              font-size: 0.3rem;
              span {
                font-size: 0.3rem;
                color: #ff5c00;
              }
            }
          }
        }
        .van-field__label {
          color: #333;
        }
        .van-cell__value {
          .van-field__control {
            color: #666;
          }
          span {
            font-size: 0.3rem;
          }
        }
      }
    }
  }
}
</style>